/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundPromptInput {
    getFixupPrototypeFunction() { return AIPlaygroundPromptInput.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundPromptInput>): AIPlaygroundPromptInput {
        let obj = Object.assign(new AIPlaygroundPromptInput(), model);
        AIPlaygroundPromptInput.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundPromptInput>): AIPlaygroundPromptInput {
        if (!model) return null;
        return AIPlaygroundPromptInput.newInstance(<AIPlaygroundPromptInput> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundPromptInput) {
        if (!obj) return;

        models.AIPlaygroundPromptInput.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundPromptInput): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundPromptInput.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User prompt
     */
    prompt: string;

    /**
     * Optional system prompt
     */
    system_prompt: string;

}
